import { DataFileExplorerAction } from "../../../Reducers/Client/DataFileExplorer/DataFileExplorerReducer"
import { DataFileExplorerType } from "../../Types"

export const addDataToFileExplorer = (id: string, data: any[]) => {
    const action: DataFileExplorerAction = {
        type: DataFileExplorerType.addData,
        payload: {
            id,
            data
        }
    }

    return action
}

export const clearDataFileExplorer = (id: string) => {
    const action: DataFileExplorerAction = {
        type: DataFileExplorerType.clearData,
        payload: { id }
    }

    return action
}
